import React, { useRef } from "react";
import { FormControl, Card, Layout, Button, usePath, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link, useLocation } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { useForm } from "react-hook-form";
import { UserInput, schema, UserFormProps } from "./UserForm.types";
import { useData } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { toast } from "react-toastify";
import { InspectionStatusInput } from "../InspectionHome/InspectionHome.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";
//import { UserFormProps, UserInput } from "./UserForm.types";



export const UserForm = (props: UserFormProps) => {
    const history = useHistory();
    const formRef = useRef<HTMLFormElement>(null);
    const config =  useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    const user =  useProfile(application) as UserSecurityInput;
    const defaultvalues = { ...props.values, dateCreated: props.values?.dateCreated?.toLocaleString().slice(0, 10) }
    const { control, handleSubmit, setValue, watch } = useForm<UserInput>({
    
        resolver: yupResolver(schema),
        defaultValues: defaultvalues
    });
 
    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }
 
    const onSubmit = useSubmitForm<UserInput>(
        'userSecurity',
        async (response) => {
            
            toast.success("User Updated Successfully");
            await timeout(2000);
            history.push(props.returnPath);

        },
        props.action
    );

    // const submit = async () => {
        
    //     if (formRef.current) {
        
    //         formRef.current.dispatchEvent(
    //             new Event('submit', { cancelable: true, bubbles: true })
    //         );

    //     }
    // }

    const submit = async () => {
        setValue('dateUpdated', new Date());
        setValue('updatedBy', user?.userName);

        if(!formRef.current) {
          return;
        }
      
        try {
          const event = new Event('submit', {
            bubbles: true,
            cancelable: true
          });
          
          document.getElementById('editUserForm')
          ?.dispatchEvent(event);
          
        } catch (error) {
            debugger;
          console.error('An error occurred while dispatching submit event: ', error);
        }
      };
   

    return (

       
        <form id={props.id}   ref={formRef} onSubmit={handleSubmit((data: UserInput) => onSubmit(data))}>
            <div className="row">
                <div className="col col-md-8">
                    <div className="card-main-title">
                        Edit User
                    </div>                    
                </div>
                
               
            </div>

            <Card.Container>

                <Card.Header>
                    <Card.Title>{props.title}</Card.Title>
                </Card.Header>

                <Card.Body>
                    {/*  ============================================================================================================================================*/}
                    <Layout.Row>   <>
                        <div className="row">
                            <div className="col col-md-4">
                            <FormControl.Text
                                    control={control}
                                    name="userClaimsObjectId"
                                    label="User Object ID"
                                    required
                              ></FormControl.Text>
                            </div>
                            <div className="col col-md-4">
                                 <FormControl.Text
                                    control={control}
                                    name="email"
                                    label="Email"                                  
                                    required
                                />
                            </div>

                             <div className="col col-md-4">
                                 <FormControl.Checkbox
                                    control={control}
                                    name="isActive"
                                    label="Is Active"                                  
                                    required
                                />
                             </div>

                             {/* <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="roleId"
                                    label="Role"                                                     
                                    required
                                />
                            </div> */}

                             <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="userName"
                                    label="User Name"                                                     
                                    required
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="lastName"
                                    label="Last Name"                                                     
                                    required
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="firstName"
                                    label="First Name"                                                     
                                    required
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="middleName"
                                    label="Middle Name"                                                     
                                    
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="phone"
                                    label="Phone"                                                     
                                    
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="address"
                                    label="Address"                                                     
                                    
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="city"
                                    label="City"                                                     
                                    
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="zipCode"
                                    label="Zip Code"                                                     
                                    
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="jobTitle"
                                    label="Job Title"                                                     
                                    
                                />
                            </div>

                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="jobDescription"
                                    label="Job Description"                                                     
                                    
                                />
                            </div>

                        </div>
                       

                       
                        {/*  ============================================================================================================================================*/}
                    </></Layout.Row>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex">
                        {/* <span className="btn btn-link" onClick={(e) => {
                            e.preventDefault();                          
                            submit()

                        }}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                <path d="M12 8l-4 4"></path>
                            </svg> Save and Exit
                        </span> */}
                        <div className="btn-list ms-auto">
                            <Link
                                to='/userManagement'
                                className="btn btn-light"
                                role="button"
                            >
                                Cancel
                            </Link>
                            <Button className="btn btn-primary ms-auto" onClick={(e) => {
                                e.preventDefault();
                               // setValue('inspectionStatusId', InspectionStatus.Complete);
                                submit()

                            }}>Save</Button>
                        </div>
                    </div>
                </Card.Footer>
            </Card.Container>
        </form>
    );
};

export default UserForm;






